import mutations from './countryCountyCity.mutations'
import actions from './countryCountyCity.actions'
import getters from './countryCountyCity.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
